module.exports = __webpack_public_path__ + "e147bd2bb2aa7f31e3804673c8564340.svg";